import { z } from 'zod';

export const subscriptionItemStatusSchema = z.enum(['active', 'available', 'default', 'free']);

export const SubscriptionItemStatus = subscriptionItemStatusSchema.enum;

export type SubscriptionItemStatus = z.infer<typeof subscriptionItemStatusSchema>;

export const subscriptionItemSchema = z.object({
    currency: z.string(),
    priceId: z.string(),
    productName: z.string(),
    status: subscriptionItemStatusSchema,
    unitAmount: z.coerce.number(),
});

export type SubscriptionItem = z.infer<typeof subscriptionItemSchema>;

export const subscriptionItemsSchema = subscriptionItemSchema.array();

export const subscriptionUpdateResultSchema = z.object({
    checkoutUrl: z.string().nullable(),
});

export type SubscriptionUpdateResult = z.infer<typeof subscriptionUpdateResultSchema>;

export const subscriptionResponseStatusSchema = z.enum([
    'ACTIVE',
    'CANCELED',
    'INCOMPLETE',
    'PAST_DUE',
    'TRIALING',
    'UNPAID',
]);

export const SubscriptionResponseStatus = subscriptionResponseStatusSchema.enum;

export type SubscriptionResponseStatus = z.infer<typeof subscriptionResponseStatusSchema>;

export const subscriptionResponseSchema = z.object({
    items: z.array(z.unknown()),
    status: subscriptionResponseStatusSchema,
    stripeId: z.string(),
});

export type SubscriptionResponse = z.infer<typeof subscriptionResponseSchema>;
